// admin Api
import request from "@/config/_request";
import qs from "qs";

const admin = true;

const postRestArgs = (params, admin = true) => ({
  data: params,
  method: "post",
  headers: {
    "Content-Type": "application/json"
  },
  admin,
})



// 登录
// export function adminLogin(params) {
//   return request({
//     url: "/api/auth/login",
//     data: qs.stringify(params),
//     method: "post",
//     admin
//   });
// }

// 获取合作学校
export function getEducationalInstitutionList(params) {
  return request({
    url: "/api/admin/get/educational_institution/list",
    params,
    method: "get",
    admin,
    noLoading: false
  });
}

/**
 * 新增体验校区
 * @param {*} params 
 * @returns 
 */
export function addTrySchool(params) {
  return request({
    url: "/java-api/admin/edu/createTry",
    ...postRestArgs(params)
  });
}

/**
 * 新增合作学校
 * @param {*} params 
 * @returns 
 */
export function addEducationalInstitution(params) {
  return request({
    url: "/java-api/admin/edu/create",
    ...postRestArgs(params)
  });
}

// 修改合作学校
export function updateEducationalInstitution(params) {
  return request({
    url: "/api/admin/update/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

/**
 * 修改体验学校
 * @param {*} params 
 * @returns 
 */
export function updateTrySchool(params) {
  return request({
    url: "/java-api/admin/edu/updateTry",
    ...postRestArgs(params)
  });
}

// 获取校长账号列表
export function getPrincipalUserList(params) {
  return request({
    url: "/api/admin/get/principal/user/list",
    params,
    method: "get",
    admin
  });
}

/**
 * 解封和封锁校长账号
 * @param {*} params 
 * @returns 
 */
export function blockadePrincipalUser(params) {
  return request({
    url: "/java-api/admin/user/updateBlockade",
    ...postRestArgs(params)
  });
}


/**
 * 添加校长账号接口
 * @param {*} params 
 * @returns 
 */
export function addPrincipalUser(params) {
  return request({
    url: "/java-api/admin/user/createPrincipal",
    ...postRestArgs(params)
  });
}

/**
 * 重置校长账号密码
 * @param {*} params 
 * @returns 
 */
export function updatePrincipalUser(params) {
  return request({
    url: "/java-api/admin/user/resetPassword",
    ...postRestArgs(params)
  });
}


// 上传轮播图
export function uploadStstemImages(params) {
  return request({
    url: "/api/admin/add/ststem/index/images",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 获取轮播图列表
export function getStstemImagesList(params) {
  return request({
    url: "/api/admin/get/ststem/index/image/list",
    params,
    method: "get",
    admin
  });
}

// 修改轮播图
export function updateStstemImages(params) {
  return request({
    url: "/api/admin/update/ststem/index/images",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 删除轮播图
export function deleteStstemImages(params) {
  return request({
    url: "/api/admin/delete/ststem/index/images",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 获取全部科目
export function getSubjectList(params) {
  return request({
    url: "/api/admin/get/subject/list",
    params,
    method: "get",
    admin
  });
}

// 获取学校和科目对应的权限表
export function getSubjectPermissions(params) {
  return request({
    url: "/api/admin/get/admin/subject/educational_institution/list",
    params,
    method: "get",
    admin
  });
}

// 添加学校和科目绑定关系
export function addSubjectPermissions(params) {
  return request({
    url: "/api/admin/add/admin/subject/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 删除学校和科目绑定关系
export function deleteSubjectPermissions(params) {
  return request({
    url: "/api/admin/delete/admin/subject/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 修改学校和科目绑定关系
export function updateSubjectPermissions(params) {
  return request({
    url: "/api/admin/update/admin/subject/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 获取学校和体系对应的权限表
export function getCurriculumPermissions(params) {
  return request({
    url: "/api/admin/get/admin/curriculum/educational_institution/list",
    params,
    method: "get",
    admin
  });
}

// 添加学校和体系绑定关系
export function addCurriculumPermissions(params) {
  return request({
    url: "/api/admin/add/admin/curriculum/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 删除学校和体系绑定关系
export function deleteCurriculumPermissions(params) {
  return request({
    url: "/api/admin/delete/admin/curriculum/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}



//添加单个视频
export function adminCreateOrUpdateVideoSingle(params) {
  return request({
    url: "/api/admin/create/or/update/video/single",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//删除单个视频
export function adminDeleteVideoSingle(params) {
  return request({
    url: "/api/admin/delete/video/single",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}


// 修改学校和体系绑定关系
export function updateAdminCurriculumForEducationalInstitution(params) {
  return request({
    url: "/api/admin/update/admin/curriculum/educational_institution",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 获取全部用户列表(admin用户除外)
export function getAdminUserList(params) {
  return request({
    url: "/api/admin/get/user/list",
    params,
    method: "get",
    admin
  });
}

// 获取学校标签列表
export function getTagList(params) {
  return request({
    url: "/api/admin/get/admin/educational_institution/tag/list",
    params,
    method: "get",
    admin
  });
}

// 添加学校标签
export function addTag(params) {
  return request({
    url: "/api/admin/add/admin/educational_institution/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 修改学校标签
export function updateTag(params) {
  return request({
    url: "/api/admin/update/admin/educational_institution/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 删除学校标签
export function deleteTag(params) {
  return request({
    url: "/api/admin/delete/admin/educational_institution/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//权限管理-创建、更新导航
export function createOrUpdatePermission(params) {
  return request({
    url: "/api/admin/create/or/update/permission",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//权限管理-获得标题列表
export function getPermissionList(params) {
  return request({
    url: "/api/get/permission/list",
    params,
    method: "get",
    admin
  });
}

//权限管理-删除标题
export function deletePermission(params) {
  return request({
    url: "/api/admin/delete/permission",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//权限管理-新增角色
export function createOrUpdateRole(params) {
  return request({
    url: "/api/admin/create/or/update/role",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//权限管理-查询角色列表
export function adminGetRoleList(params) {
  return request({
    url: "/api/admin/get/role/list",
    params,
    method: "get",
    admin
  });
}

//权限管理-删除角色
export function adminDeleteRole(params) {
  return request({
    url: "/api/admin/delete/role",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//社区权限管理-新增或更新标签
export function adminCreateOrUpdateWorkTag(params) {
  return request({
    url: "/api/admin/create/or/update/work/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询平台标签
export function adminGetWorkTagList(params) {
  return request({
    url: "/api/admin/get/work/tag/list",
    params,
    method: "get",
    admin
  });
}

//平台删除标签
export function adminDeleteWorkTag(params) {
  return request({
    url: "/api/admin/delete/work/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//社区轮播图配置
export function adminAddOrUpdateZoneBanner(params) {
  return request({
    url: "/api/admin/add/or/update/zone/banner",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询社区轮播图
export function adminGetZoneBannerList(params) {
  return request({
    url: "/api/admin/get/zone/banner/list",
    params,
    method: "get",
    admin
  });
}

//删除默认轮播图
export function deleteZoneBanner(params) {
  return request({
    url: "/api/delete/zone/banner",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//社区轮播图配置-赛考中心
export function adminAddOrUpdateSchoolBanner(params) {
  return request({
    url: "/api/admin/add/or/school/banner",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询社区轮播图-赛考中心
export function adminGetSchoolBannerList(params) {
  return request({
    url: "/api/admin/get/school/banner/list",
    params,
    method: "get",
    admin
  });
}

//删除默认轮播图-赛考中心
export function adminDeleteSchoolBanner(params) {
  return request({
    url: "/api/admin/delete/school/banner",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询ChatGPT 
export function adminGetGhatGptKey(params) {
  return request({
    url: "/api/admin/get/chatGptKey",
    params,
    method: "get",
    admin
  });
}

//保存ChatGPT_KEY
export function adminCreateChatGptKey(params) {
  return request({
    url: "/api/admin/create/chatGptKey",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}



//新增学校标签
export function adminAddOrUpdateSchoolTag(params) {
  return request({
    url: "/api/admin/add/or/update/school/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询标签
export function adminGetSchoolTagList(params) {
  return request({
    url: "/api/admin/get/school/tag/list",
    params,
    method: "get",
    admin
  });
}

//删除标签
export function adminDeleteSchoolTag(params) {
  return request({
    url: "/api/admin/delete/school/tag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//添加或更新培训视频 分类
export function adminCreateOrUpdateVideoType(params) {
  return request({
    url: "/api/admin/create/or/update/video/type",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询视频分类列表
export function getVideoTypeList(params) {
  return request({
    url: "/api/get/video/type/list",
    params,
    method: "get",
    admin
  });
}

//删除视频分类
export function adminDeleteVideoType(params) {
  return request({
    url: "/api/admin/delete/video/type",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//新增培训视频
export function adminCreateOrUpdateVideo(params) {
  return request({
    url: "/api/admin/create/or/update/video",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//获得培训视频列表
export function adminGetVideoList(params) {
  return request({
    url: "/api/admin/get/video/list",
    params,
    method: "get",
    admin
  });
}

//删除培训视频
export function adminDeleteVideo(params) {
  return request({
    url: "/api/admin/delete/video",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//添加物料类型
export function adminCreateOrUpdateMeterialType(params) {
  return request({
    url: "/api/admin/create/or/update/meterial/type",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询物料类型
export function getMeterialTypeList(params) {
  return request({
    url: "/api/get/meterial/type/list",
    params,
    method: "get",
    admin
  });
}

//删除物料分类列表
export function adminDeleteMeterialType(params) {
  return request({
    url: "/api/admin/delete/meterial/type",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//添加或更新物料包
export function adminCreateOrUpdateMeterialGroup(params) {
  return request({
    url: "/api/admin/create/or/update/meterial/group",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//查询物料包
export function adminGetMeterialGroupList(params) {
  return request({
    url: "/api/admin/get/meterial/group/list",
    params,
    method: "get",
    admin
  });
}

//删除物料包
export function adminDeleteMeterialGroup(params) {
  return request({
    url: "/api/admin/delete/meterial/group",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//添加或更新物料
export function adminCreateOrUpdateMeterial(params) {
  return request({
    url: "/api/admin/create/or/update/meterial",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//删除物料
export function adminDeleteMeterial(params) {
  return request({
    url: "/api/admin/delete/meterial",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//更新培训视频发布状态
export function adminUpdateVideoPostState(params) {
  return request({
    url: "/api/admin/update/video/post/state",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//更新物料发布状态
export function adminUpdateMeterialGroupPostState(params) {
  return request({
    url: "/api/admin/update/meterial/group/post/state",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

/**
 * 修改校长账号信息
 * @param {*} params 
 * @returns 
 */
export function updatePrincipalUserInfo(params) {
  return request({
    url: "/java-api/admin/user/updatePrincipalInfo",
    ...postRestArgs(params)
  });
}

//根据校区id查询校区科目
export function adminGetSchoolSubjectList(params) {
  return request({
    url: "/api/admin/get/school/subject/list",
    params,
    method: "get",
    admin
  });
}

//超管查询校区自有课程
export function adminGetSchoolCurriculumList(params) {
  return request({
    url: "/api/admin/get/school/curriculum/list",
    params,
    method: "get",
    admin: admin
  });
}

//超管审核校区课程
export function adminCheckCurriculum(params) {
  return request({
    url: "/api/admin/check/curriculum",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//超管给校区增加空间和流量订单
export function adminAddOrUpdateSchoolOrder(params) {
  return request({
    url: "/api/admin/add/or/update/school/order",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//超管查询校区订单
export function adminGetSchoolOrderList(params) {
  return request({
    url: "/api/admin/get/school/order/list",
    params,
    method: "get",
    admin: admin
  });
}

//超级管理员-新建题库
export function adminAddOrUpdateQuestionBank(params) {
  return request({
    url: "/api/admin/add/or/update/question/bank",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//查询平台题库
export function adminGetQuestionBankList(params) {
  return request({
    url: "/api/admin/get/question/bank/list",
    params,
    method: "get",
    admin: admin
  });
}

//删除平台题库
export function adminDeleteQuestionBank(params) {
  return request({
    url: "/api/admin/delete/question/bank",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//改变题库发布状态
export function adminChangeQuestionBankPostState(params) {
  return request({
    url: "/api/admin/change/question/bank/post/state",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//平台题库-添加试题
export function adminAddOrUpdateQuestion(params) {
  return request({
    url: "/api/admin/add/or/update/question",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//超管获得题库题目列表
export function adminGetQuestionList(params) {
  return request({
    url: "/api/admin/get/question/list",
    params,
    method: "get",
    admin: admin
  });
}

//超管删除题目
export function adminDeleteQuestion(params) {
  return request({
    url: "/api/admin/delete/question",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//添加校区下载文件
export function adminCreateOrUpdateSchoolFile(params) {
  return request({
    url: "/api/admin/create/or/update/school/file",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//获得校区文件列表
export function adminGetSchoolFileList(params) {
  return request({
    url: "/api/admin/get/school/file/list",
    params,
    method: "get",
    admin: admin
  });
}

export function adminDeleteSchoolFile(params) {
  return request({
    url: "/api/admin/delete/school/file",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}


/**
 * 批量添加校区课程权限
 * @param {*} params 
 * @returns 
 */
export function bulkAddCurriculumAuth(params) {
  return request({
    url: "/java-api/admin/eduCurrPer/save",
    ...postRestArgs(params)
  });
}


//批量修改校区到期时间
export function bulkUpdateCurriculumAuth(params) {
  return request({
    url: "/api/admin/bulk/update/curriculum/auth",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//批量删除
export function bulkDeleteCurrOfSchool(params) {
  return request({
    url: "/api/admin/bulkDeleteCurrOfSchool",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//添加系统通知
export function adminAddOrUpdateNotice(params) {
  return request({
    url: "/api/admin/add/or/update/notice",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//获得系统通知
export function adminGetNoticeList(params) {
  return request({
    url: "/api/admin/get/notice/list",
    params,
    method: "get",
    admin: admin
  });
}

//删除通知
export function adminDeleteNotice(params) {
  return request({
    url: "/api/admin/delete/notice",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//删除校区订单
export function adminDeleteSchoolOrder(params) {
  return request({
    url: "/api/admin/delete/school/order",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//数据看板 计算平台概况数据
export function adminCreateSysTotalInfo(params) {
  return request({
    url: "/api/admin/create/sys/total/info",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//获得最新的平台概况
export function adminGetLatestSysTotalInfo(params) {
  return request({
    url: "/api/admin/get/latest/sys/total/info",
    params,
    method: "get",
    admin: admin
  });
}

//获得平台概况趋势图
export function adminGetSysTotalInfoList(params) {
  return request({
    url: "/api/admin/get/sys/total/info/list",
    params,
    method: "get",
    admin: admin
  });
}

//计算校区实施看板
export function adminCreateSysSchoolEffectInfo(params) {
  return request({
    url: "/api/admin/create/sys/school/effect/info",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//获得实施看板分数

export function adminGetSysSchoolEffectTotalInfo(params) {
  return request({
    url: "/api/admin/get/sys/school/effect/total/info",
    params,
    method: "get",
    admin: admin
  });
}

//实施数据详情

export function adminGetSysSchoolEffectInfoList(params) {
  return request({
    url: "/api/admin/get/sys/school/effect/info/list",
    params,
    method: "get",
    admin: admin
  });
}

//计算学校运营看板数据
export function adminCreateSysSchoolOperationInfo(params) {
  return request({
    url: "/api/admin/create/sys/school/operation/info",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//学校学员数概况
export function adminGetSchoolNumByNormalStuNum(params) {
  return request({
    url: "/api/admin/get/school/num/by/normal/stu/num",
    params,
    method: "get",
    admin: admin
  });
}

//学校员工数概况
export function adminGetSchoolNumByUserNum(params) {
  return request({
    url: "/api/admin/get/school/num/by/user/num",
    params,
    method: "get",
    admin: admin
  });
}

//根据科目查看学员分布
export function adminGetStuNumBySubject(params) {
  return request({
    url: "/api/admin/get/stu/num/by/subject",
    params,
    method: "get",
    admin: admin
  });
}

//根据科目查看校区分布
export function adminGetSchoolNumBySchoolSubject(params) {
  return request({
    url: "/api/admin/get/school/num/by/school/subject",
    params,
    method: "get",
    admin: admin
  });
}

//获得课堂反馈信息
export function adminGetLessonFeedbackList(params) {
  return request({
    url: "/api/admin/get/lesson/feedback/list",
    params,
    method: "get",
    admin: admin
  });
}

//教研回复课堂满意度
export function adminUpdateLessonFeedbackReplay(params) {
  return request({
    url: "/api/admin/update/lesson/feedback/replay",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//课程满意度统计
export function adminGetLessonFeedbackCountInfo(params) {
  return request({
    url: "/api/admin/get/lesson/feedback/count/info",
    params,
    method: "get",
    admin: admin
  });
}

//根据柱状图查询校区
export function adminGetSchoolListBySysInfoCondition(params) {
  return request({
    url: "/api/admin/get/school/list/by/sys/info/condition",
    params,
    method: "get",
    admin: admin
  });
}

//校区运营数据趋势图
export function adminGetSysSchoolOperationInfoList(params) {
  return request({
    url: "/api/admin/get/sys/school/teaching/info/list",
    params,
    method: "get",
    admin: admin
  });
}

//超管查询平台教学计划
export function adminGetTchPlanList(params) {
  return request({
    url: "/api/admin/get/tch/plan/list",
    params,
    method: "get",
    admin: admin
  });
}

//超管查询公众平台行业信息
export function getIndustry(params) {
  return request({
    url: "/api/wechat_agent/get/industry",
    params,
    method: "get",
    admin: admin
  });
}

//获得模板消息列表
export function getTemplateList(params) {
  return request({
    url: "/api/wechat_agent/get/template/list",
    params,
    method: "get",
    admin: admin
  });
}

//超管同步模板消息
export function addTemplates(params) {
  return request({
    url: "/api/wechat_agent/add/templates",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管系统设置接口
//查询标题列表
export function adminGetAuthPermissionList(params) {
  return request({
    url: "/api/admin/get/auth/permission/list",
    params,
    method: "get",
    admin: admin
  });
}

//新增、修改标题
export function adminCreateOrUpdateAuthPermission(params) {
  return request({
    url: "/api/admin/create/or/update/auth/permission",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//删除后台标题
export function adminDeleteAuthPermission(params) {
  return request({
    url: "/api/admin/delete/auth/permission",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//获得后台角色
export function adminGetAuthRoleList(params) {
  return request({
    url: "/api/admin/get/auth/role/list",
    params,
    method: "get",
    admin: admin
  });
}

//新增后台角色
export function adminCreateOrUpdateAuthRole(params) {
  return request({
    url: "/api/admin/create/or/update/auth/role",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管新增员工账号
export function adminAddOrUpdateAuthUser(params) {
  return request({
    url: "/api/admin/add/or/update/auth/user",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//获得员工列表
export function adminGetAuthUserList(params) {
  return request({
    url: "/api/admin/get/auth/user/list",
    params,
    method: "get",
    admin: admin
  });
}

//超管后台删除员工
export function adminDeleteAuthUser(params) {
  return request({
    url: "/api/admin/delete/auth/user",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管封号、解封员工账号
export function adminCloseAuthUser(params) {
  return request({
    url: "/api/admin/close/auth/user",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管重置员工密码
export function adminUpdateAuthUserPassword(params) {
  return request({
    url: "/api/admin/update/auth/user/password",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管后台员工登录页面
export function authNewLogin(params) {
  return request({
    url: "/api/auth/new/login",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管后台员工修改账号密码
export function adminAuthUserUpdatePassword(params) {
  return request({
    url: "/api/admin/auth/user/update/password",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//员工发布客户跟进记录
export function adminAddOrUpdateAuthSchoolRecord(params) {
  return request({
    url: "/api/admin/add/or/update/auth/school/record",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//查询学校跟进记录
export function adminGetAuthSchoolRecordList(params) {
  return request({
    url: "/api/admin/get/auth/school/record/list",
    params,
    method: "get",
    admin: admin
  });
}

//删除沟通记录
export function adminDeleteAuthSchoolRecord(params) {
  return request({
    url: "/api/admin/delete/auth/school/record",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管后台刷新数据addCurriculum
export function adminFreshAuthUserData(params) {
  return request({
    url: "/api/admin/fresh/auth/user/data",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//教研活动
export function adminGetResearchActivityList(params) {
  return request({
    url: "/api/admin/get/research/activity/list",
    params,
    method: "get",
    admin: admin
  })
}
//教研活动/添加课程
export function addCurriculum(params) {
  return request({
    url: "/api/admin/add/or/update/research/activity",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//教研活动/获取科目
export function getAdminSubjectList(params) {
  return request({
    url: "/api/admin/get/subject/list",
    params,
    method: "get",
    admin: admin
  });
}
//教研活动/是否置顶
export function isTopping(params) {
  return request({
    url: "/api/admin/update/research/activity/new/state",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//教研活动删除
export function del(params) {
  return request({
    url: "/api/admin/delete/research/activity",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//添加师训
export function addtraining(params) {
  return request({
    url: "/api/admin/add/or/update/tch/training",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//超管获得教师训
export function getList(params) {
  return request({
    url: "/api/admin/get/tch/training/list",
    params,
    method: "get",
    admin: admin
  })
}

//更新师训发布状态
export function isState(params) {
  return request({
    url: "/api/admin/update/tch/training/post/state",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管删除师训
export function delTraining(params) {
  return request({
    url: "/api/admin/delete/tch/training",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得师训章节
export function getChapterList(params) {
  return request({
    url: "/api/admin/get/tch/training/chapter/list",
    params,
    method: "get",
    admin: admin
  });
}
//添加或更新师训章节
export function editChapter(params) {
  return request({
    url: "/api/admin/add/or/update/tch/training/chapter",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//删除师训章节
export function delChapter(params) {
  return request({
    url: "/api/admin/delete/tch/training/chapter",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//获得师训视频列表
export function getVideoList(params) {
  return request({
    url: "/api/admin/get/tch/training/video/list",
    params,
    method: "get",
    admin: admin
  });
}

//添加或更新师训视频
export function editVideo(params) {
  return request({
    url: "/api/admin/add/or/update/tch/training/video",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//删除师训视频
export function delVideo(params) {
  return request({
    url: "/api/admin/delete/tch/training/video",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得观看了师训的教师列表
export function readerList(params) {
  return request({
    url: "/api/admin/get/tch/training/reader/list",
    params,
    method: "get",
    admin: admin
  });
}

//获得观看了教研的教师列表
export function tchList(params) {
  return request({
    url: "/api/admin/get/research/activity/tch/list",
    params,
    method: "get",
    admin: admin
  });
}
//获取教师账号列表
export function schoolTchList(params) {
  return request({
    url: "/api/admin/get/tch/list",
    params,
    method: "get",
    admin: admin
  });
}

/**
 * 超管更新教师离职状态
 * @param {*} params 
 * @returns 
 */
export function updateState(params) {
  return request({
    url: "/java-api/admin/user/updateWorkState",
    ...postRestArgs(params)
  });
}

//编辑学校到期时间
export function adminEditSchoolOfftime(params) {
  return request({
    url: "/api/admin/edit/school/offtime",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得学校的到期时间操作记录
export function adminGetSchoolOfftimeRecord(params) {
  return request({
    url: "/api/admin/get/school/offtime/record",
    params,
    method: "get",
    admin: admin
  });
}
//暂停学校接口
export function adminStopSchool(params) {
  return request({
    url: "/api/admin/stop/school",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//启用学校接口
export function adminStartSchool(params) {
  return request({
    url: "/api/admin/start/school",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}


/**
 * 为多个学校批量添加课程体系权限
 * @param {*} params 
 * @returns 
 */
export function bulkAddCurriculumAuthForSchools(params) {
  return request({
    url: "/java-api/admin/eduCurrPer/saveBatch",
    ...postRestArgs(params)
  });
}


//获取单个校区
export function adminGetSchoolInfoById(params) {
  return request({
    url: "/api/admin/get/school/info/by/id",
    params,
    method: "get",
    admin: admin
  });
}

//获得用户修改用户名记录
export function adminGetHistoryUserNameList(params) {
  return request({
    url: "/api/admin/get/history/username/list",
    params,
    method: "get",
    admin: admin
  });
}
//获得用户截屏记录
export function adminGetCatchScreenRecordList(params) {
  return request({
    url: "/api/admin/get/catch/screen/record/list",
    params,
    method: "get",
    admin: admin
  });
}
//超级管理后台 - 批量修改科目权限到期时间
export function bulkUpdateSchoolSubjectAuthOfftime(params) {
  return request({
    url: "/api/admin/bulk/update/school/subject/auth/offtime",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管获得学校校区列表
export function adminGetSchoolCampusList(params) {
  return request({
    url: "/api/admin/get/school/campus/list",
    params,
    method: "get",
    admin: admin
  });
}
//超管修改校区教师人数
export function adminUpdateSchoolCampus(params) {
  return request({
    url: "/api/admin/update/school/campus",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管快速修改体验校区二级域名和校长账号
export function adminChangeTrySchoolDomainAndHeadmast(params) {
  return request({
    url: "/api/admin/change/try/school/domain/and/headmaster",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管删除用户教师角色
export function adminDeleteUserTchRole(params) {
  return request({
    url: "/api/admin/delete/user/tch/role",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获取教师账号列表
export function adminGetSchoolUserLoginInfo(params) {
  return request({
    url: "/api/admin/get/school/user/login/info",
    params,
    method: "get",
    admin: admin
  });
}
//更新学校星级和状态
export function adminUpdateSchoolStarNum(params) {
  return request({
    url: "/api/admin/update/school/starnum/or/implementtype",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//批量添加c++课程对应的题目
export function adminBulkAddCppLessonOjProblem(params) {
  return request({
    url: "/api/admin/bulk/add/cpp/lesson/oj/problem",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得c++课程题目列表
export function adminGetCppLessonOjProblemList(params) {
  return request({
    url: "/api/admin/get/cpp/lesson/oj/problem/list",
    params,
    method: "get",
    admin: admin
  });
}
//删除c++课程对应的题目
export function adminDeleteCppLessonOjProblem(params) {
  return request({
    url: "/api/admin/delete/cpp/lesson/oj/problem",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//更新c++课程题目的排序号
export function adminUpdateCppLessonOjProblemSortnuma(params) {
  return request({
    url: "/api/admin/update/cpp/lesson/oj/problem/sortnum",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//创建或更新套餐
export function adminMealCreateOrUpdate(params) {
  return request({
    url: "/api/admin/meal/createOrUpdate",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得套餐列表
export function adminMealGet(params) {
  return request({
    url: "/api/admin/meal/get",
    params,
    method: "get",
    admin: admin
  });
}
//创建或更新套餐
export function adminMealDelete(params) {
  return request({
    url: "/api/admin/meal/delete",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管更新套餐有效性
export function adminMealUpdateVaild(params) {
  return request({
    url: "/api/admin/meal/updateVaild",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//添加或更新机构套餐信息
export function adminUpdateEducationalInstitutionMeal(params) {
  return request({
    url: "/api/admin/update/educational/institution/meal",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

//获得标题列表
export function adminGetPermissionList(params) {
  return request({
    url: "/api/admin/get/permission/list",
    params,
    method: "get",
    admin: admin
  });
}

//添加或更新合同
export function adminAddOrUpdateContract(params) {
  return request({
    url: "/api/admin/add/or/update/contract",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管获得合同列表
export function adminGetContract(params) {
  return request({
    url: "/api/admin/get/contract",
    params,
    method: "get",
    admin: admin
  });
}
//删除合同
export function adminDeleteContract(params) {
  return request({
    url: "/api/admin/delete/contract",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管获得学校权限操作记录
export function adminGetSchoolAuthRecordList(params) {
  return request({
    url: "/api/admin/get/school/auth/record/list",
    params,
    method: "get",
    admin: admin
  });
}
//添加或更新编辑器提示
export function adminCreateOrUpdateEditorRemark(params) {
  return request({
    url: "/api/admin/create/or/update/editorRemark",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得编辑器提示
export function adminGetEditorRemark(params) {
  return request({
    url: "/api/admin/get/editorRemark",
    params,
    method: "get",
    admin: admin
  });
}
//删除编辑器提示
export function adminDeleteEditorRemark(params) {
  return request({
    url: "/api/admin/delete/editorRemark",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//新增题库来源
export function adminAddOrUpdateTestQuestionBankSourc(params) {
  return request({
    url: "/api/admin/addOrUpdateTestQuestionBankSource",
    params,
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管查询题库来源列表
export function adminGetTestQuestionBankSourceList(params) {
  return request({
    url: "/api/admin/getTestQuestionBankSourceList",
    params,
    method: "get",
    admin: admin
  });
}
//超管删除题库来源
export function adminDeleteTestQuestionBankSource(params) {
  return request({
    url: "/api/admin/deleteTestQuestionBankSource",
    params,
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//超管查询题库来源列表(不分页)
export function adminGetTestQuestionBankSourceListWit(params) {
  return request({
    url: "/api/admin/getTestQuestionBankSourceList/withoutPage",
    params,
    method: "get",
    admin: admin
  });
}
//获得平台端模板列表
export function getAdminWxTemplateList(params) {
  return request({
    url: "/api/admin/getAdminWxTemplateList",
    params,
    method: "get",
    admin: admin
  });
}
//获得微信端模板列表
export function wechatGetTemplateList(params) {
  return request({
    url: "/api/admin/wechat/getTemplateList",
    params,
    method: "get",
    admin: admin
  });
}
//删除微信端模板
export function wechatDeleteTemplate(params) {
  return request({
    url: "/api/admin/wechat/wechatDeleteTemplate",
    params,
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//同步模板
export function adminSyncTemplateToPlateform(params) {
  return request({
    url: "/api/admin/adminSyncTemplateToPlateform",
    params,
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//删除模板
export function adminDeleteTemplateOfPlateform(params) {
  return request({
    url: "/api/admin/adminDeleteTemplateOfPlateform",
    params,
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//同步平台模板到学校模板库
export function adminSyncTemplateToSchool(params) {
  return request({
    url: "/api/admin/adminSyncTemplateToSchool",
    params,
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}
//获得学校的平台端模板列表
export function adminGetSchoolTemplateList(params) {
  return request({
    url: "/api/admin/adminGetSchoolTemplateList",
    params,
    method: "get",
    admin: admin
  });
}
//查询授权了微信第三方的合作校区
export function adminGetWechatAuthSchoolList(params) {
  return request({
    url: "/api/admin/adminGetWechatAuthSchoolList",
    params,
    method: "get",
    admin: admin
  });
}
//删除ChatGPT_KEY
export function adminDeleteChatGptKey(params) {
  return request({
    url: "/api/admin/delete/chatGptKey",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超级管理员 - 获取全部科目不分页
export function getAdminSubjectListWithOutPageInfo(params) {
  return request({
    url: "/api/admin/get/getAdminSubjectListWithOutPageInfo",
    params,
    method: "get",
    admin: admin
  });
}
//超管获得学生列表
export function adminGetStudentList(params) {
  return request({
    url: "/api/admin/adminGetStudentList",
    params,
    method: "get",
    admin: admin
  });
}
//超管添加或更新题库年份
export function adminAddOrUpdateTestQuestionBankYear(params) {
  return request({
    url: "/api/admin/addOrUpdateTestQuestionBankYear",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管查询题库年份列表
export function adminGetTestQuestionBankYearList(params) {
  return request({
    url: "/api/admin/getTestQuestionBankYearList",
    params,
    method: "get",
    admin: admin
  });
}
//超管删除题库年份
export function adminDeleteTestQuestionBankYear(params) {
  return request({
    url: "/api/admin/deleteTestQuestionBankYear",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//获得题库来源分项列表
export function adminGetTestQuestionBankSourceTagList(params) {
  return request({
    url: "/api/admin/getTestQuestionBankSourceTagList",
    params,
    method: "get",
    admin: admin
  });
}
//新增编辑
export function addOrUpdateTestQuestionBankSourceTag(params) {
  return request({
    url: "/api/admin/addOrUpdateTestQuestionBankSourceTag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//删除题库来源
export function adminDeleteTestQuestionBankSourceTag(params) {
  return request({
    url: "/api/admin/deleteTestQuestionBankSourceTag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//不分页题库来源分项列表
export function adminGetTestQuestionBankSourceTagListWithoutPage(params) {
  return request({
    url: "/api/admin/getTestQuestionBankSourceTagLis/withoutPage",
    params,
    method: "get",
    admin: admin
  });
}
//分页获得题库年份列表
export function adminGetTestQuestionBankYearListWithoutPage(params) {
  return request({
    url: "/api/admin/getTestQuestionBankYearList/withoutPage",
    params,
    method: "get",
    admin: admin
  });
}
//超管添加或更新题目标签分组
export function adminAddOrUpdateTestQuestionTagGroup(params) {
  return request({
    url: "/api/admin/addOrUpdateTestQuestionTagGroup",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//获得题目标签分组列表
export function adminGetTestQuestionTagGroupList(params) {
  return request({
    url: "/api/admin/getTestQuestionTagGroupList",
    params,
    method: "get",
    admin: admin
  });
}
// 超管删除题目标签分组  
export function adminDeleteTestQuestionTagGroup(params) {
  return request({
    url: "/api/admin/deleteTestQuestionTagGroup",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管查询题目标签分组不分页
export function adminGetTestQuestionTagGroupListWithoutPage(params) {
  return request({
    url: "/api/admin/getTestQuestionTagGroupList/withoutPage",
    params,
    method: "get",
    admin
  });
}
//超管添加或更新题目标签
export function adminAddOrUpdateTestQuestionTag(params) {
  return request({
    url: "/api/admin/addOrUpdateTestQuestionTag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管查询题目标签列表
export function adminGetTestQuestionTagList(params) {
  return request({
    url: "/api/admin/getTestQuestionTag",
    params,
    method: "get",
    admin
  });
}
//超管删除题目标签
export function adminDeleteTestQuestionTag(params) {
  return request({
    url: "/api/admin/deleteTestQuestionTag",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管查询题目标签不分页
export function adminGetTestQuestionTagListWithoutPage(params) {
  return request({
    url: "/api/admin/getTestQuestionTagList/withoutPage",
    params,
    method: "get",
    admin
  });
}
//超管获得题目列表
export function adminGetTestQuestionList(params) {
  return request({
    url: "/api/admin/getTestQuestionList",
    params,
    method: "get",
    admin
  });
}
//超管添加活更新试卷
export function adminAddOrUpdatePaper(params) {
  return request({
    url: "/api/admin/addOrUpdatePaper",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管获得试卷列表
export function adminGetPaperList(params) {
  return request({
    url: "/api/admin/getPaperList",
    params,
    method: "get",
    admin
  });
}
//超管删除试卷
export function adminDeletePaper(params) {
  return request({
    url: "/api/admin/deletePaper",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管查看试卷试题
export function adminGetCheckPaperQuestionList(params) {
  return request({
    url: "/api/admin/getCheckPaperQuestionList",
    params,
    method: "get",
    admin
  });
}
//超管试卷添加题目页面查询题目接口
export function adminGetTestQuestionListForPaperAddQu(params) {
  return request({
    url: "/api/admin/getTestQuestionListForPaperAddQuestion",
    params,
    method: "get",
    admin
  });
}
//超管向试卷中添加题目
export function adminAddQuestionToPaper(params) {
  return request({
    url: "/api/admin/addQuestionToPaper",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管删除试卷中的题目
export function adminDeleteQuestionFromPaper(params) {
  return request({
    url: "/api/admin/deleteQuestionFromPaper",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超级管理员更新程序题显示类型
export function adminUpdateQuestionShowType(params) {
  return request({
    url: "/api/admin/updateQuestionShowType",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//获得程序题的一组题目
export function adminGetTestQuestionByBankIdAndCodeOther(params) {
  return request({
    url: "/api/admin/getTestQuestionByBankIdAndCodeOther",
    params,
    method: "get",
    admin
  });
}
//赛考中心相关页面获得科目列表
export function adminGetUniqueSubjectList(params) {
  return request({
    url: "/api/admin/getUniqueSubjectList",
    params,
    method: "get",
    admin
  });
}
//超级管理员更新程序题显示类型
export function adminUpdateQuestionTitleOther(params) {
  return request({
    url: "/api/admin/updateQuestionTitleOther",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//更新试卷题目分数 
export function adminUpdatePaperQuestionScore(params) {
  return request({
    url: "/api/admin/updatePaperQuestionScore",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
//超管获得题库信息
export function adminGetQuestionBankInfo(params) {
  return request({
    url: "/api/admin/getQuestionBankInfo",
    params,
    method: "get",
    admin
  });
}
//通过科目id获得知识点标签列表，不分页
export function adminGetTestQuestionTagListBySubjectIdWithoutPage(params) {
  return request({
    url: "/api/admin/getTestQuestionTagListBySubjectId/withoutPage",
    params,
    method: "get",
    admin
  });
}

//超关修改题库题目排序号
export function adminUpdateQuestionSortNum(params) {
  return request({
    url: "/api/admin/pdateQuestionSortNum",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//题库从平台添加题目，搜索题目列表
export function adminGetTestQuestionListForBankAddQuestion(params) {
  return request({
    url: "/api/admin/getTestQuestionListForBankAddQuestion",
    params,
    method: "get",
    admin
  });
}

//复制平台题目到题库
export function adminCopyQuestionToBank(params) {
  return request({
    url: "/api/admin/copyQuestionToBank",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//取消题目分组
export function adminUpdateQuestionBulkOperateCode(params) {
  return request({
    url: "/api/admin/updateQuestionBulkOperateCode",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

//重置微信公众号机构授权信息 schoolId 机构ID
export function adminResetSchoolWxAuthorized(params) {
  return request({
    url: "/api/admin/adminResetSchoolWxAuthorized",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

/**
 * 超管 数据看板-访问记录列表
 */
export function api_adminVisitRecordSelectList(params) {
  return request({
    url: "/java-api/admin/visitRecord/selectList",
    ...postRestArgs(params)
  });
}